
import { Button } from "@/components/ui/button";

const EpisodesCTA = () => {
  return (
    <section className="w-full bg-gradient-to-r from-brand-purple to-golden-orange text-white">
      <div className="w-full py-20 lg:py-24">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6">
            Never Miss an Episode!
          </h2>
          <p className="text-xl lg:text-2xl mb-10 opacity-90 leading-relaxed">
            Subscribe to our newsletter and be the first to know when new Bobo & Teedee® episodes are released.
          </p>
          <Button asChild size="lg" variant="secondary" className="bg-white text-brand-purple hover:bg-white/90 text-xl px-10 py-6 rounded-full shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300">
            <a href="/contact">Subscribe Now</a>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default EpisodesCTA;
